<!--
 * @Author: caizexin caizexin@kjgb.net
 * @Date: 2026-02-04 09:19:38
 * @LastEditors: caizexin caizexin@kjgb.net
 * @LastEditTime: 2026-03-20 15:13:24
 * @FilePath: \vue-app-console\src\views\AdvancedFunction\ErgoAdjust.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
    <div>
        <Header :headerData="headerData"></Header>

        <div class="query_box" >
            <a-select
                class="query_field"
                v-model:value="searchForm.sku"
                :placeholder="t('access.sku')"
                allowClear
                :options="skuOptions"
                style="width: 300px;"
                show-search
                @focus="handleFocus"
                @search="fetchSKU"
                @change="handleSelectChange"
            ></a-select>
            <a-button type="primary" size="small" style="margin-left:10px" @click="handleSearch">
                <img src="@/assets/image/search.png" alt="" width="15" style="margin-right: 5px;margin-top:-3px">
                {{ $t('base.search') }}
            </a-button>
        </div>

        <a-button type="primary" size="small" style="margin-bottom:10px" @click="handle('add')">
            <plus-outlined /> {{ $t('base.add') }}
        </a-button>

        <Table
            class="table"
            :table="table"
            @handleChangePagination="handleChangePagination"
        >
            <template v-slot:tableAction="{props}">
                <template v-if="props.column.key === 'action'">
                    <a-button type="primary" size="small" style="margin-right:10px" @click="handle('edit', props.record)">
                        {{ $t('base.edit') }}
                    </a-button>
                    <a-button size="small" style="margin-right:10px" @click="handle('delete', props.record)">
                        {{ $t('base.delete') }}
                    </a-button>
                    <a-button size="small" @click="handle('record', props.record)">
                        {{ $t('base.record') }}
                    </a-button>
                </template>
            </template>
        </Table>

        <!-- 人体工学调节 -->
        <a-modal
            v-model:open="ergoAdjustVisible"
            centered
            :maskClosable="false"
            width="70%"
            @ok="handleErgoAdjust"
            @cancel="ergoAdjustVisible = false"
        >
            <template #title>
                <setting-outlined /> {{ modalTitle }}
            </template>
            
            <div class="ergoAdjustForm">
                <a-descriptions bordered :column="2"> 
                    <a-descriptions-item :label="t('access.sku2')" :labelStyle="{textAlign: 'left'}">
                        <a-input v-model:value="ergoAdjustFormData.sku" :disabled="operateType == 'edit'" style="width: 100%"></a-input>
                    </a-descriptions-item>
                    <a-descriptions-item :label="t('access.seat_tube_angle2')" :labelStyle="{textAlign: 'left'}">
                        <a-input-number v-model:value="ergoAdjustFormData.seat_tube_angle" :min="-360" :max="360" :precision="2" style="width: 100%">
                            <template #addonAfter>°</template>
                        </a-input-number>
                    </a-descriptions-item>
                    <a-descriptions-item :label="t('access.seat_tube_length2')" :labelStyle="{textAlign: 'left'}">
                        <a-input-number v-model:value="ergoAdjustFormData.seat_tube_length" :min="0" :max="9999" :precision="2" style="width: 100%">
                            <template #addonAfter>mm</template>
                        </a-input-number>
                    </a-descriptions-item>
                    <a-descriptions-item :label="t('access.stem_adjustable2')" :labelStyle="{textAlign: 'left'}">
                        <a-select v-model:value="ergoAdjustFormData.stem_adjustable" style="width: 100%">
                            <a-select-option :value="0">{{ $t('base.yes') }}</a-select-option>
                            <a-select-option :value="1">{{ $t('base.no') }}</a-select-option>
                        </a-select>
                    </a-descriptions-item>
                    
                    <a-descriptions-item :label="t('access.stem_pivot_height2')" :labelStyle="{textAlign: 'left'}">
                        <a-input-number v-model:value="ergoAdjustFormData.stem_pivot_height" :min="0" :max="9999" :precision="2" style="width: 100%">
                            <template #addonAfter>mm</template>
                        </a-input-number>
                    </a-descriptions-item>
                    <a-descriptions-item :label="t('access.stem_length_max2')" :labelStyle="{textAlign: 'left'}">
                        <a-input-number v-model:value="ergoAdjustFormData.stem_length_max" :min="0" :max="9999" :precision="2" style="width: 100%">
                            <template #addonAfter>mm</template>
                        </a-input-number>
                    </a-descriptions-item>
                    <a-descriptions-item :label="t('access.saddle_to_seattube_max2')" :labelStyle="{textAlign: 'left'}">
                        <a-input-number v-model:value="ergoAdjustFormData.saddle_to_seattube_max" :min="0" :max="9999" :precision="2" style="width: 100%">
                            <template #addonAfter>mm</template>
                        </a-input-number>
                    </a-descriptions-item>
                    <a-descriptions-item :label="t('access.ergo_adjust_factor2')" :labelStyle="{textAlign: 'left'}">
                        <a-input-number v-model:value="ergoAdjustFormData.ergo_adjust_factor" :min="0" :max="9999" :precision="2" style="width: 100%"></a-input-number>
                    </a-descriptions-item>

                    <a-descriptions-item :label="t('access.inner_leg_length_max2')" :labelStyle="{textAlign: 'left'}">
                        <a-input-number v-model:value="ergoAdjustFormData.inner_leg_length_max" :min="0" :max="9999" :precision="2" style="width: 100%" @change="handleInnerLegLengthChange('max')">
                            <template #addonAfter>mm</template>
                        </a-input-number>
                    </a-descriptions-item>
                    <a-descriptions-item :label="t('access.inner_leg_length_min2')" :labelStyle="{textAlign: 'left'}">
                        <a-input-number v-model:value="ergoAdjustFormData.inner_leg_length_min" :min="0" :max="9999" :precision="2" style="width: 100%" @change="handleInnerLegLengthChange('min')">
                            <template #addonAfter>mm</template>
                        </a-input-number>
                    </a-descriptions-item>
                    <a-descriptions-item :label="t('access.body_height_max2')" :labelStyle="{textAlign: 'left'}">
                        <a-input-number v-model:value="ergoAdjustFormData.body_height_max" :min="0" :max="9999" :precision="2" style="width: 100%" @change="handleBodyHeightChange('max')">
                            <template #addonAfter>cm</template>
                        </a-input-number>
                    </a-descriptions-item>
                    <a-descriptions-item :label="t('access.body_height_min2')" :labelStyle="{textAlign: 'left'}">
                        <a-input-number v-model:value="ergoAdjustFormData.body_height_min" :min="0" :max="9999" :precision="2" style="width: 100%" @change="handleBodyHeightChange('min')">
                            <template #addonAfter>cm</template>
                        </a-input-number>
                    </a-descriptions-item>

                    <a-descriptions-item :label="t('access.bike_max_payload2')" :labelStyle="{textAlign: 'left'}">
                        <a-input-number v-model:value="ergoAdjustFormData.bike_max_payload" :min="0" :max="9999" :precision="2" style="width: 100%">
                            <template #addonAfter>kg</template>
                        </a-input-number>
                    </a-descriptions-item>
                    <a-descriptions-item :label="t('access.bike_weight2')" :labelStyle="{textAlign: 'left'}">
                        <a-input-number v-model:value="ergoAdjustFormData.bike_weight" :min="0" :max="9999" :precision="2" style="width: 100%">
                            <template #addonAfter>kg</template>
                        </a-input-number>
                    </a-descriptions-item>
                    <a-descriptions-item :label="t('access.head_set_cap_height2')" :labelStyle="{textAlign: 'left'}">
                        <a-input-number v-model:value="ergoAdjustFormData.head_set_cap_height" :min="0" :max="9999" :precision="2" style="width: 100%">
                            <template #addonAfter>mm</template>
                        </a-input-number>
                    </a-descriptions-item>
                    <a-descriptions-item :label="t('access.head_tube_angle2')" :labelStyle="{textAlign: 'left'}">
                        <a-input-number v-model:value="ergoAdjustFormData.head_tube_angle" :min="-360" :max="360" :precision="2" style="width: 100%">
                            <template #addonAfter>°</template>
                        </a-input-number>
                    </a-descriptions-item>

                    <a-descriptions-item :label="t('access.reach2')" :labelStyle="{textAlign: 'left'}">
                        <a-input-number v-model:value="ergoAdjustFormData.reach" :min="0" :max="9999" :precision="2" style="width: 100%">
                            <template #addonAfter>mm</template>
                        </a-input-number>
                    </a-descriptions-item>
                    <a-descriptions-item :label="t('access.stack2')" :labelStyle="{textAlign: 'left'}">
                        <a-input-number v-model:value="ergoAdjustFormData.stack" :min="0" :max="9999" :precision="2" style="width: 100%">
                            <template #addonAfter>mm</template>
                        </a-input-number>
                    </a-descriptions-item>
                </a-descriptions>
            </div>
        </a-modal>


        <!-- 编辑记录 -->
        <a-modal
            v-model:open="editRecordVisible"
            centered
            :maskClosable="false"
            width="80%"
        >
            <template #title>
                <clock-circle-outlined /> {{ $t('access.editRecord') }}
            </template>
    
            <div v-if="editRecordData.length > 0">
                <a-collapse v-model:activeKey="activeKey" accordion>
                    <a-collapse-panel
                        v-for="(item,index) in editRecordData"
                        :key="index" 
                        :header="item.title"
                    >
                        <a-table 
                            :dataSource="item.records" 
                            :columns="recordTableColumns" 
                            :pagination="false"
                        />
                    </a-collapse-panel>
                </a-collapse>
            </div>
            <a-empty v-else />
        </a-modal>
    </div>
</template>

<script setup>
    import { ref, reactive, computed, onMounted, nextTick, watch} from "vue";
    import { useRoute, useRouter } from "vue-router";
    import { useI18n } from 'vue-i18n';
    import { message, Modal } from 'ant-design-vue';
    import { getWeek } from '@/hooks/useGetWeek';
    import { AdvancedFunApi } from '@/api/AdvancedFunApi.js';
    import Header from "@/layouts/component/Header.vue";
    import Table from "@/components/Table.vue";
    import { timestampToDate } from '@/utils/global';
    import { useDebounceFn } from '@vueuse/core';

    const { t } = useI18n()

    const headerData = ref({
        menu:'menu.ErgoAdjust',
        menu_desc: 'menu.subErgoAdjust',
        week: getWeek().week,
        current_time: getWeek().currentDate,
    })

    const searchForm = reactive({
        sku: null,
    })
    const skuOptions = ref([])
    const modalTitle = ref('')
    const ergoAdjustVisible = ref(false)
    const editRecordVisible = ref(false)
    const operateType = ref('add')
    const activeKey = ref([])
    const rowData = ref(null)
    const ergoAdjustFormData = reactive({
        sku: '',
        seat_tube_length: '',
        seat_tube_angle: '',
        stem_adjustable: '',
        stem_pivot_height: '',
        stem_length_max: '',
        saddle_to_seattube_max: '',
        inner_leg_length_max: '',
        inner_leg_length_min: '',
        body_height_max: '',
        body_height_min: '',
        ergo_adjust_factor: '',
        bike_max_payload: '',
        bike_weight: '',
        head_set_cap_height: '',
        head_tube_angle: '',
        reach: '',
        stack: '',
    })
    const table = ref({
        data: [],
        columns: [
            {
                title: t('access.sku'),
                dataIndex: 'sku',
                key: 'sku',
                width: 180,
                resizable: true,
            },
            {
                title: t('access.seat_tube_angle'),
                dataIndex: 'seat_tube_angle',
                key: 'seat_tube_angle',
                width: 200,
                resizable: true,
            },
            {
                title: t('access.seat_tube_length'),
                dataIndex: 'seat_tube_length',
                key: 'seat_tube_length',
                width: 200,
                resizable: true,
            },
            {
                title: t('access.stem_adjustable'),
                dataIndex: 'stem_adjustable',
                key: 'stem_adjustable',
                width: 180,
                resizable: true,
            },
            {
                title: t('access.stem_pivot_height'),
                dataIndex: 'stem_pivot_height',
                key: 'stem_pivot_height',
                width: 200,
                resizable: true,
            },
            {
                title: t('access.stem_length_max'),
                dataIndex: 'stem_length_max',
                key: 'stem_length_max',
                width: 200,
                resizable: true,
            },
            {
                title: t('access.saddle_to_seattube_max'),
                dataIndex: 'saddle_to_seattube_max',
                key: 'saddle_to_seattube_max',
                width: 200,
                resizable: true,
            },
            {
                title: t('access.inner_leg_length_max'),
                dataIndex: 'inner_leg_length_max',
                key: 'inner_leg_length_max',
                width: 200,
                resizable: true,
            },
            {
                title: t('access.inner_leg_length_min'),
                dataIndex: 'inner_leg_length_min',
                key: 'inner_leg_length_min',
                width: 200,
                resizable: true,
            },
            {
                title: t('access.body_height_max'),
                dataIndex: 'body_height_max',
                key: 'body_height_max',
                width: 180,
                resizable: true,
            },
            {
                title: t('access.body_height_min'),
                dataIndex: 'body_height_min',
                key: 'body_height_min',
                width: 180,
                resizable: true,
            },
            {
                title: t('access.ergo_adjust_factor'),
                dataIndex: 'ergo_adjust_factor',
                key: 'ergo_adjust_factor',
                width: 180,
                resizable: true,
            },
            {
                title: t('access.bike_max_payload'),
                dataIndex: 'bike_max_payload',
                key: 'bike_max_payload',
                width: 180,
                resizable: true,
            },
            {
                title: t('access.bike_weight'),
                dataIndex: 'bike_weight',
                key: 'bike_weight',
                width: 160,
                resizable: true,
            },
            {
                title: t('access.head_set_cap_height'),
                dataIndex: 'head_set_cap_height',
                key: 'head_set_cap_height',
                width: 170,
                resizable: true,
            },
            {
                title: t('access.head_tube_angle'),
                dataIndex: 'head_tube_angle',
                key: 'head_tube_angle',
                width: 160,
                resizable: true,
            },
            {
                title: t('access.reach'),
                dataIndex: 'reach',
                key: 'reach',
                width: 100,
                resizable: true,
            },
            {
                title: t('access.stack'),
                dataIndex: 'stack',
                key: 'stack',
                width: 100,
                resizable: true,
            },
            {
                title: t('access.create_timestamp'),
                dataIndex: 'create_timestamp',
                key: 'create_timestamp',
                width: 200,
                resizable: true,
            },
            {
                title: t('access.update_timestamp'),
                dataIndex: 'update_timestamp',
                key: 'update_timestamp',
                width: 200,
                resizable: true,
            },
            {
                title: t('base.operate'),
                key: 'action',
                fixed: 'right',
                width: 250,
            },
        ],
        configs: {
            table: {
                rowClassName:(record, index) => (index % 2 === 1 ? 'table-striped' : null)
            },
            scroll: {
                x: 1800,
                y: 550,//设置表格高度，固定表头
            },
            rowSelection: false,
            loading: false,
            pagination:{
                hideOnSinglePage:false,
                position:['bottomLeft'],
                responsive:true,// size 未指定时，根据屏幕宽度自动调整尺寸
                current:1,
                pageSize:10,
                pageSizeOptions:['10','20','50'],
                total:0,
                // showTotal:()=>t('base.total') + ` ${table.value.configs.pagination.total} ` + t('base.row')
            },
            operateBtn: {
                showSearch: false,
                showAdd: false,
            }
        },
    })

    const editRecordData = ref([])
    const recordTableColumns = ref([
            {
                title: t('access.sku'),
                dataIndex: 'sku',
                key: 'sku',
                width: 180,
                resizable: true,
            },
            {
                title: t('access.field_name'),
                dataIndex: 'field_name',
                key: 'field_name',
                width: 200,
                resizable: true,
            },
            {
                title: t('access.new_value'),
                dataIndex: 'new_value',
                key: 'new_value',
                width: 200,
                resizable: true,
            },
            {
                title: t('access.old_value'),
                dataIndex: 'old_value',
                key: 'old_value',
                width: 200,
                resizable: true,
            },
            {
                title: t('access.operation_type'),
                dataIndex: 'operation_type',
                key: 'operation_type',
                width: 180,
                resizable: true,
            },
    ])


    const handleSelectChange = ()=>{
        table.value.configs.pagination.current = 1
        getErgoAdjustList()
    }

    const handleSearch = ()=>{
        table.value.configs.pagination.current = 1
        getErgoAdjustList()
    }

    const handleChangePagination = (config)=>{
        table.value.configs.pagination.current = config.current
        table.value.configs.pagination.pageSize = config.pageSize
        getErgoAdjustList()
    }

    const handle = (type, row)=>{
        switch(type){
            case 'add':
                ergoAdjustVisible.value = true
                operateType.value = 'add'
                modalTitle.value = t('access.addErgoAdjustParams')
                for(let key in ergoAdjustFormData){
                    ergoAdjustFormData[key] = ''
                }
                break
            case 'edit':
                ergoAdjustVisible.value = true
                operateType.value = 'edit'
                modalTitle.value = t('access.editErgoAdjustParams')
                for(let key in ergoAdjustFormData){
                    ergoAdjustFormData[key] = row[key] == '-' ? '' : row[key].split(' ')[0]
                    if(key == 'stem_adjustable'){
                        ergoAdjustFormData[key] = row.stem_adjustable_val
                    }
                }
                break
            case 'delete':
                Modal.confirm({
                    title: t('base.tip'),
                    content: t('base.deleteConfirm'),
                    onOk:()=>{
                        deleteSKUErgoAdjust(row)
                    },
                })
                break
            case 'record':
                editRecordVisible.value = true
                rowData.value = row
                getEditRecord(row.sku)
                break
        }
    }

    const handleInnerLegLengthChange = useDebounceFn((type)=>{
        if(type == 'max'){
            if(ergoAdjustFormData.inner_leg_length_min !== '' && ergoAdjustFormData.inner_leg_length_min !== null && ergoAdjustFormData.inner_leg_length_max !== '' && ergoAdjustFormData.inner_leg_length_max !== null && ergoAdjustFormData.inner_leg_length_min > ergoAdjustFormData.inner_leg_length_max){
                message.error(t('access.inner_leg_length_max_error'))
            }
        }
        if(type == 'min'){
            if(ergoAdjustFormData.inner_leg_length_min !== '' && ergoAdjustFormData.inner_leg_length_min !== null && ergoAdjustFormData.inner_leg_length_max !== '' && ergoAdjustFormData.inner_leg_length_max !== null && ergoAdjustFormData.inner_leg_length_max < ergoAdjustFormData.inner_leg_length_min){
                message.error(t('access.inner_leg_length_min_error'))
            }
        }
    }, 300)

    const handleBodyHeightChange = useDebounceFn((type)=>{
        if(type == 'max'){
            if(ergoAdjustFormData.body_height_min !== '' && ergoAdjustFormData.body_height_min !== null && ergoAdjustFormData.body_height_max !== '' && ergoAdjustFormData.body_height_max !== null && ergoAdjustFormData.body_height_min > ergoAdjustFormData.body_height_max){
                message.error(t('access.body_height_max_error'))
            }
        }
        if(type == 'min'){
            if(ergoAdjustFormData.body_height_min !== '' && ergoAdjustFormData.body_height_min !== null && ergoAdjustFormData.body_height_max !== '' && ergoAdjustFormData.body_height_max !== null && ergoAdjustFormData.body_height_max < ergoAdjustFormData.body_height_min){
                message.error(t('access.body_height_min_error'))
            }
        }
    }, 300)

    const getErgoAdjustList = async ()=>{
        let param = {
            sku: searchForm.sku,
        }
        let page_num = table.value.configs.pagination.current
        let page_size = table.value.configs.pagination.pageSize

        table.value.configs.loading = true
        let res = await AdvancedFunApi.getInstance().getErgoAdjustList(param, page_num, page_size)
        if(res.code === 0){
            let fieldArrMM = [
                'seat_tube_length','stem_pivot_height', 'stem_length_max', 'saddle_to_seattube_max', 
                'inner_leg_length_max', 'head_set_cap_height', 'reach', 'stack'
            ]
            let fieldArrCM = ['body_height_max','body_height_min']
            let fieldArrKG = ['bike_max_payload','bike_weight']
            let fieldArrAngle = ['seat_tube_angle','head_tube_angle']
            
            res.data.records.forEach(item => {
                for(let key in ergoAdjustFormData){
                    if(key != 'stem_adjustable' && key != 'sku'){
                        item[key] = item[key] == undefined ? '-' : fieldArrAngle.includes(key)? `${item[key]} °` : fieldArrMM.includes(key)? `${item[key]} mm` : fieldArrCM.includes(key)? `${item[key]} cm` : `${item[key]} kg`
                    }
                }
                item.stem_adjustable_val = item.stem_adjustable
                item.stem_adjustable = item.stem_adjustable == 0 ? t('base.yes') : t('base.no')
                item.create_timestamp = item.create_timestamp == undefined ? '-' : timestampToDate(item.create_timestamp * 1000)
                item.update_timestamp = item.update_timestamp == undefined ? '-' : timestampToDate(item.update_timestamp * 1000)
            })
            table.value.data = res.data.records
            table.value.configs.pagination.total = res.data.total
            table.value.configs.loading = false
        }else{
            message.error(res.msg || res.message)
        }
    }

    const validErgoAdjustForm = ()=>{
        for(let key in ergoAdjustFormData){
            if(ergoAdjustFormData[key] === '' || ergoAdjustFormData[key] === null){
                message.error(t('access.'+key).split('：')[0]+' '+t('base.noEmpty'))
                return false
            }
        }

        if(ergoAdjustFormData.inner_leg_length_min > ergoAdjustFormData.inner_leg_length_max){
            message.error(t('access.inner_leg_length_max_error'))
            return false
        }
        if(ergoAdjustFormData.body_height_min > ergoAdjustFormData.body_height_max){
            message.error(t('access.body_height_max_error'))
            return false
        }
        return true
    }

    // 保存人体工学调节
    const handleErgoAdjust = async ()=>{
        if(!validErgoAdjustForm()) return

        let param = {
            ...ergoAdjustFormData,
        }
        console.log(param,'param')
        let res = await AdvancedFunApi.getInstance().saveErgoAdjustParams(param, param.sku, operateType.value == 'add' ? 0 : 1)
        if(res.code === 0){
            message.success(t('base.saveSuccessMsg'))
            ergoAdjustVisible.value = false
            table.value.configs.pagination.current = 1
            getErgoAdjustList()
        }else{
            message.error(res.msg || res.message)
        }
    }


    // 删除SKU几何参数
    const deleteSKUErgoAdjust = async (row)=>{
        let res = await AdvancedFunApi.getInstance().deleteSKUErgoAdjust(row.id)
        if(res.code === 0){
            message.success(t('base.deleteSuccessMsg'))
            getErgoAdjustList()
        }else{
            message.error(res.msg || res.message)
        }
    }

    // 获取SKU列表
    const getSKUList = async ()=>{
        let param = {
            sku: searchForm.sku == null ? '' : searchForm.sku,
        }
        let res = await AdvancedFunApi.getInstance().getSKUList(param)
        if(res.code === 0){
            skuOptions.value = res.data.map(item => ({
                label: item,
                value: item,
            }))
        }else{
            message.error(res.msg || res.message)
        }
    }

    const fetchSKU = useDebounceFn(async (val)=>{
        searchForm.sku = val
        getSKUList()
    },300) 

    const handleFocus = ()=>{
        searchForm.sku = ''
        getSKUList()
    }


    // 获取编辑记录
    const getEditRecord = async ()=>{
        let res = await AdvancedFunApi.getInstance().getEditRecordList(rowData.value.sku)
        if(res.code === 0){
            let fieldArrMM = [
                'SEAT_TUBE_LENGTH','STEM_PIVOT_HEIGHT', 'STEM_LENGTH_MAX', 'SADDLE_TO_SEATTUBE_MAX', 
                'INNER_LEG_LENGTH_MAX', 'HEAD_SET_CAP_HEIGHT', 'REACH', 'STACK'
            ]
            let fieldArrCM = ['BODY_HEIGHT_MAX','BODY_HEIGHT_MIN']
            let fieldArrAngle = ['SEAT_TUBE_ANGLE','HEAD_TUBE_ANGLE']
            let fieldArrSKU = ['SKU']

            res.data.forEach(item => {
                item.title = timestampToDate(item.create_timestamp * 1000)
                item.records.forEach(sub => {
                    sub.sku = !sub.sku? '-' : sub.sku
                    sub.field_name = !sub.field_name? '-' : sub.field_name
                    sub.new_value = sub.new_value == undefined ? '-' : fieldArrMM.includes(sub.field_name)? `${sub.new_value} mm` : fieldArrCM.includes(sub.field_name)? `${sub.new_value} cm` : fieldArrAngle.includes(sub.field_name)? `${sub.new_value} °` : fieldArrSKU.includes(sub.field_name)? `${sub.new_value}` : `${sub.new_value} kg`
                    sub.old_value = sub.old_value == undefined ? '-' : fieldArrMM.includes(sub.field_name)? `${sub.old_value} mm` : fieldArrCM.includes(sub.field_name)? `${sub.old_value} cm` : fieldArrAngle.includes(sub.field_name)? `${sub.old_value} °` : `${sub.old_value} kg`
                    sub.operation_type = sub.operation_type == 0? t('base.edit') : sub.operation_type == 1? t('base.add') : t('base.delete')
                })
            })
            editRecordData.value = res.data

            console.log(editRecordData.value,'editRecordData')
        }else{
            message.error(res.msg || res.message)
        }
    }


    onMounted(async ()=>{
        getSKUList()
        await getErgoAdjustList()
        
    })
</script>

<style lang="scss" scoped>
::v-deep .page_header .week{
    margin-top: -55px;
    transform: translateY(8px);
}
::v-deep .page_header .admin_email{
    margin-top: -55px;
    transform: translateY(18px);
}

.query_box{
    margin:40px 0 20px;
}

.ergoAdjustForm{
    margin-top: 20px;
}
::v-deep .ant-input-number-group-addon{
    width:50px !important;
}
::v-deep .ant-descriptions-item-label{
    font-weight: 600;
    background:#f1f1f1 !important;
}

::v-deep .ant-table-wrapper .ant-table-thead>tr>th, 
::v-deep .ant-table-wrapper .ant-table-tbody>tr>td, 
::v-deep .ant-table-wrapper tfoot>tr>td{
    padding: 6px 16px;
}

</style>